import api from '../../../services/Api';
import { IAuditoriaReceitasDiferidasResultado } from '../interfaces/IAuditoriaReceitasDiferidas';

export const AuditoriaReceitasDiferidasService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaReceitasDiferidasResultado> {
    const response = await api.get<IAuditoriaReceitasDiferidasResultado>('auditoria-receitas-diferidas/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoSegregacao: '',
        receitasDiferidasPendentes: [],
        receitasDiferidasConciliadas: [],
      }
    );
  },
};
